module.exports = __webpack_public_path__ + "img/clinic-left.e9dc6605.png";